var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClock2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_374_7583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7726 12.6783L11.82 10.4638V5.95299C11.82 5.49943 11.4534 5.13281 10.9999 5.13281C10.5463 5.13281 10.1797 5.49943 10.1797 5.95299V10.874C10.1797 11.1323 10.3011 11.3759 10.5078 11.5301L13.7884 13.9906C13.936 14.1013 14.1083 14.1546 14.2797 14.1546C14.5298 14.1546 14.7758 14.0422 14.9366 13.8257C15.209 13.464 15.1351 12.9497 14.7726 12.6783Z",
    fill: "#838BB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9984 0.21875C5.15968 0.21875 0.410156 4.96828 0.410156 10.807C0.410156 16.6457 5.15968 21.3952 10.9984 21.3952C16.8371 21.3952 21.5866 16.6457 21.5866 10.807C21.5866 4.96828 16.8371 0.21875 10.9984 0.21875ZM10.9984 19.7549C6.06514 19.7549 2.05046 15.7402 2.05046 10.807C2.05046 5.87374 6.06514 1.85906 10.9984 1.85906C15.9325 1.85906 19.9463 5.87374 19.9463 10.807C19.9463 15.7402 15.9316 19.7549 10.9984 19.7549Z",
    fill: "#838BB4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_374_7583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1765,
    height: 21.1765,
    fill: "white",
    transform: "translate(0.410156 0.21875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock2);
export default __webpack_public_path__ + "static/media/icon-clock-2.2cc7c0654b2325295b276f290c763eb7.svg";
export { ForwardRef as ReactComponent };